import { CustomSeriesOption, EChartsOption, graphic } from "echarts";
import goldBallImg from "@/assets/img/黄色小球2.png";

export const WAKE_LENGTH = 30; // 尾迹数量
export const chartWidth = 250;
export const chartHeight = 250;
// Charts center
const centerX = chartWidth / 2;
const centerY = chartHeight / 2;

function polarToCartesian(radius: number, angle: number) {
  // 将角度从度数转换为弧度，因为三角函数在JavaScript/TypeScript中使用的是弧度制
  // const angleInRadians = (angle * Math.PI) / 180; // 顺时针方向
  const angleInRadians = ((360 - angle) * Math.PI) / 180; // 逆时针方向

  // 根据极坐标到笛卡尔坐标的转换公式计算x和y坐标
  const x = centerX + radius * Math.cos(angleInRadians);
  const y = centerY + radius * Math.sin(angleInRadians);

  return [x, y];
}

// 将笛卡尔坐标系转为极坐标
export const cartesianToPolar = (x: number, y: number) => {
  // 计算角度，使用Math.atan2函数，它接收两个参数：y和x，并返回一个角度值，范围是-π到π。
  const angle = (Math.atan2(y, x) * 180) / Math.PI;

  // 计算半径，使用Math.sqrt函数，它接收一个参数，即x和y的平方之和，并返回一个数值，表示半径。
  const radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  return [radius, angle];
};

const getCircle = (
  radius = 40,
  border = "#7ea39c",
  fill: any = "rgba(0,0,0,.0)"
) => {
  // radius 圆的半径
  return function (params: any, api: any) {
    const center = [centerX, centerY];
    const points = [];
    for (let i = 0; i < 360; i++) {
      const x = center[0] + radius * Math.cos((i * Math.PI) / 180);
      const y = center[1] + radius * Math.sin((i * Math.PI) / 180);
      points.push([x, y]);
    }
    const res = {
      type: "polygon",
      shape: {
        points: points,
      },
      style: {
        stroke: border, // 黑色边框
        lineWidth: 2, // 边框宽度为 1px
      },
    } as any;
    if (fill) res.style.fill = fill;
    return res;
  } as CustomSeriesOption;
};



export const getChartDefaulOpiotns3 = (radius = 2, angle = 0, radius2 = 0) => {
  radius = radius < 1.1 ? 1.1 : radius; // 防止小球消失
  const showLine = false;
  const max = 10000;
  const min = 0;
  const value = [radius, angle];

  // 计算每单位长度对应的像素数
  const xUnitPixel = (chartWidth - 0) / (max - min);
  const radiusInPixel1 = Math.floor(xUnitPixel * radius) / 2; // 换算成像素

  const colorxy = polarToCartesian(radiusInPixel1, angle);

  const radiusInPixel2 = Math.floor(xUnitPixel * radius2) / 2; // 换算成像素

  const option = {
    // backgroundColor: "#848b95",
    backgroundColor: "#000",
    animation: false,

    polar: {
      center: ["50%", "50%"], // 极坐标系的中心位置
      radius: "100%", // 极坐标系的半径
    },
    grid: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },

    radiusAxis: {
      type: "value",
      min,
      max,
      interval: 5000,
      axisLine: {
        show: false,
        lineStyle: {
          width: 2,
          color: "#ffffff",
        },
      },
      splitLine: {
        // 内部圆
        show: true,
        lineStyle: {
          color: "#ffffff",
          width: 1,
        },
      },
      axisLabel: {
        show: false,
        color: "#ffffff",
      },
    },
    angleAxis: {
      min: 0,
      max: 360,
      interval: 90,
      startAngle: 0,
      clockwise: false, // 设置为 false 表示逆时针方向
      splitLine: {
        // 十字星分割线
        show: true,
        lineStyle: {
          color: "#ffffff99",
          width: 4,
        },
      },
      axisLine: {
        // 外部圆
        show: false,
        lineStyle: {
          color: "#ffffff",
          width: 6,
        },
      },
      axisLabel: {
        show: false,
        color: "#ffffff",
      },
    },

    series: [
      // 连接线
      {
        coordinateSystem: "polar",
        name: "line",
        type: "line",
        z: 998,
        zlevel: 998,
        data: [[0, 0], value],
        lineStyle: {
          width: 10,
          // color: "rgba(255, 235, 59, 0.5)",
          // 线性渐变
          color: {
            type: "linear",
            x: centerX,
            y: centerY,
            x2: colorxy[0],
            y2: colorxy[1],
            colorStops: [
              {
                offset: 0,
                color: "rgba(255, 235, 59, 0)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(255, 235, 59, 0.4)", // 0% 处的颜色
              },
              {
                offset: 0.7,
                color: "rgba(255, 235, 59, .9)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(255, 235, 59, 1)", // 100% 处的颜色
              },
            ],
            global: true, // 缺省为 false
          },
        },
        showSymbol: false,
        emphasis: {
          focus: "series",
        },
      },
      // 小球
      {
        animation: false,
        symbolSize: 20,
        data: [value],
        type: "scatter",
        coordinateSystem: "polar",
        z: 999,
        zlevel: 999,
        // clip: false,
        itemStyle: {
          opacity: 1,
          color: "#ffd700", // 基础颜色
          shadowColor: "#888888", // 阴影颜色
          shadowBlur: 10, // 阴影模糊程度
          // shadowOffsetX: 2, // 阴影偏移量
          // shadowOffsetY: 2, // 阴影偏移量
        },
        symbol: `image://${goldBallImg}`,
      },
      // 圆圈
      {
        name: "圆圈1",
        type: "pie",
        z: 4,
        radius: [0, radiusInPixel2],
        center: ["50%", "50%"],
        data: [100],
        hoverAnimation: false,
        itemStyle: {
          // color: "rgba(255,255,255,0.1)",

          color: new graphic.RadialGradient(
            0.5, // 圆心 x 坐标
            0.5, // 圆心 y 坐标
            0.7, // 开始半径 (通常设为 0 表示从中心点开始)
            [
              { offset: 0, color: "rgba(0,0,0,0.8)" }, // 圆内颜色 (结束颜色)
              { offset: 1, color: "rgba(255,255,255,0.1)" }, // 圆外颜色 (开始颜色)
            ]
          ),
          borderWidth: 4,
          borderColor: "#ffd700",
        },
        labelLine: {
          show: false,
        },
        label: {
          show: false,
        },
      },
    ],
  } as EChartsOption;

  return option;
};
